<template lang="pug">
    v-layout(style="height:60px;")
            v-flex.xs4.text-sm-left.pt-3.subheading
                span.pl-5(v-if="from && to && total") resultados del {{from}} al {{to}} de {{total}}
            v-flex.xs4.text-sm-center
                v-pagination(v-model="pagination.page" :color="colors.tertiary" :length="length" total-visible="5")
            v-flex.xs4.text-sm-right
                div.d-flex.pr-5(style="margin-top: -8px;")
                    span.pr-3.subheading.pt-4(style="") resultados por página
                    v-select(v-model="pagination.rowsPerPage" :items="[15, 30, 40, 60, 80, 100]" style="width: 10px;")
</template>

<script>
export default {
    name: 'data-table-pagination',
    props: {
        value: {
            required: true
        },
        length: {
            required: true
        },
        from: {
            default: null
        },
        to: {
            default: null
        },
        total:{
            default: null
        }
    },
    data: function(){
        return {}
    },
    computed: {
        pagination: {
            get: function(){
                return this.value
            },
            set: function(val){
                this.$emit('input', val)
            }
        }
    },
    methods: {},
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>